import { render, staticRenderFns } from "./KhaiwhanTransfer.vue?vue&type=template&id=24f7ced2&"
import script from "./KhaiwhanTransfer.vue?vue&type=script&lang=js&"
export * from "./KhaiwhanTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports